<template>
  <div class="alert-tips" :class="tipsClassName" v-if="shows">
    <div class="tips-prefix" v-if="isPrefix">
      <i class="el-alert__icon" :class="isPreficIcon"></i>
    </div>
    <div class="tips-title">{{ title }}</div>
    <div class="tips-close finger-style" v-if="showIcon" @click="shows = false">
      <i class="el-alert__icon el-icon-error"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertTips',
  computed: {
    tipsClassName() {
      return `${this.type}-tips`;
    },
    shows: {
      get: function() {
        return this.showTips;
      },
      set: function(value) {
        this.$emit('showsChange', value);
      },
    },
  },
  props: {
    type: {
      type: String,
      default: 'success', // success error
      required: false,
    },
    title: {
      type: String,
      default: '',
      required: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
      required: false,
    },
    isPrefix: {
      type: Boolean,
      default: false,
      required: false,
    },
    isPreficIcon: {
      type: String,
      default: 'el-icon-warning-outline',
      required: false,
    },
    showTips: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  model: {
    prop: 'showTips',
    event: 'showsChange',
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
